import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sidebar",
  "use": "sidebar-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sidebar\"><path fill-rule=\"evenodd\" d=\"M1 1h18v18H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol